var _rect, _text, _text2, _g, _line, _path, _circle, _circle2, _circle3, _circle4, _g2, _g3, _g4, _g5, _g6, _g7, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase2Fig3D021D022Supersession(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 600",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 600,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Lock, incident, supersession, follow-up: 48 hours")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "A gate-green merge falsified D-021, D-022 inverted the posture, and #277 shipped the pre-registered fix inside a day.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 12,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 174,
    y: 138
  }, "2026-07-08"), /*#__PURE__*/React.createElement("text", {
    x: 742,
    y: 138
  }, "2026-07-09"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 158,
    x2: 1138,
    y2: 158,
    stroke: "#D4DDD6",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1136 152 l12 6 l-12 6 z",
    fill: "#D4DDD6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 158,
    r: 7,
    fill: "#6B7F74",
    stroke: "#FFFDF7",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 158,
    r: 7,
    fill: "#DC2626",
    stroke: "#FFFDF7",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 742,
    cy: 158,
    r: 7,
    fill: "#16A34A",
    stroke: "#FFFDF7",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1026,
    cy: 158,
    r: 7,
    fill: "#16A34A",
    stroke: "#FFFDF7",
    strokeWidth: 3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontSize: 11,
    fill: "#6B7F74",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 182
  }, "posture inverted"), /*#__PURE__*/React.createElement("text", {
    x: 884,
    y: 182
  }, "within a day"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 174,
    y1: 169,
    x2: 174,
    y2: 206
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458,
    y1: 169,
    x2: 458,
    y2: 206
  }), /*#__PURE__*/React.createElement("line", {
    x1: 742,
    y1: 169,
    x2: 742,
    y2: 206
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1026,
    y1: 169,
    x2: 1026,
    y2: 206
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 210,
    width: 252,
    height: 264,
    rx: 12,
    fill: "#F5F2E8",
    stroke: "#D4DDD6",
    strokeWidth: 1.5,
    strokeDasharray: "6 4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 242,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#6B7F74"
  }, "LOCKED, LATER SUPERSEDED"), /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 276,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 22,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "D-021"), /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 298,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 12,
    fill: "#6B7F74"
  }, "2026-07-08"), /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 330,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Human-gated"), /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 348,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "production sync"), /*#__PURE__*/React.createElement("g", {
    fontSize: 11.5,
    fill: "#4A5F56"
  }, /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 378
  }, "Locks the human-gated"), /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 395
  }, "production sync. Schema"), /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 412
  }, "pushes to production go"), /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 429
  }, "through the founder gate.")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 332,
    y: 210,
    width: 252,
    height: 264,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#DC2626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 242,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#DC2626"
  }, "INCIDENT"), /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 276,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 22,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "#273"), /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 298,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 12,
    fill: "#6B7F74"
  }, "2026-07-09"), /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 330,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "A gate-green merge"), /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 348,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "breaks production"), /*#__PURE__*/React.createElement("g", {
    fontSize: 11.5,
    fill: "#4A5F56"
  }, /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 378
  }, "A gate-green merge deploys"), /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 395
  }, "code querying a column the"), /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 412
  }, "founder-gated schema push"), /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 429
  }, "had not created. The human"), /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 446
  }, "gate itself 500s production.")))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 616,
    y: 210,
    width: 252,
    height: 264,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 242,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "SUPERSESSION"), /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 276,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 22,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "D-022"), /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 298,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 12,
    fill: "#6B7F74"
  }, "2026-07-09"), /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 330,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Auto-apply in the"), /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 348,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "production build"), /*#__PURE__*/React.createElement("g", {
    fontSize: 11.5,
    fill: "#4A5F56"
  }, /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 378
  }, "Schema plus full catalog"), /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 395
  }, "auto-applying inside the"), /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 412
  }, "production build, fail-closed,"), /*#__PURE__*/React.createElement("text", {
    x: 636,
    y: 429
  }, "creds in the build env.")))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 900,
    y: 210,
    width: 252,
    height: 264,
    rx: 12,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 242,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.1em",
    fill: "#16A34A"
  }, "PRE-REGISTERED FOLLOW-UP"), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 276,
    fontFamily: "'Geist Mono', Consolas, monospace",
    fontSize: 22,
    fontWeight: 700,
    fill: "#1A2F2A"
  }, "#277"), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 330,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Named risk 1,"), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 348,
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "shipped within a day"), /*#__PURE__*/React.createElement("g", {
    fontSize: 11.5,
    fill: "#4A5F56"
  }, /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 378
  }, "Ships D-022's own named"), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 395
  }, "risk 1: a migrate-based"), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 412
  }, "deploy path, a squashed"), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 429
  }, "baseline, a schema-drift"), /*#__PURE__*/React.createElement("text", {
    x: 920,
    y: 446
  }, "guard in CI.")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 556,
    fontSize: 13.5,
    fontWeight: 500,
    fill: "#1A2F2A"
  }, "The lock had already named its reversal trigger and its risks, so falsification cost one day and the fix was pre-registered.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase2Fig3D021D022Supersession);
export default __webpack_public_path__ + "static/media/case2-fig3-d021-d022-supersession.e81170ba13f65fcf2d10a26706a18177.svg";
export { ForwardRef as ReactComponent };